/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, message, Form } from 'antd';
import axios from "axios";
import dot from 'dot-object';
import { View } from "./view";
import { EditForm } from "../../form";
import { getInputProp, mapFormGroup } from "../../helper";
import useQuery from "../../../../helpers/useQuery";
import i18next from "i18next";
import { propHasValue } from "../../../../components/DynamicFormNew/helper";
import { useNavigate } from "react-router";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getApiBaseUrl, getAppHeader } from "../../../../services/BaseService";

function AjaxModal({
  authentication: { user },
  formsValue = {},
  allFormsValue = {},
  name,
  inputName = null,
  props = {},
  call = null,
  // automaticallyLink = null,
  value = null,
  onNewSetValue = null,
  // modalTitle = null,
  buttonText = null,
  repeatIndex = null,
  repeatValues = {},
  totalInputs = null,
  shownInputs = {},
  // updateOptions = false,
  // mainForm = null,
  allowDupplicates = false,
  onChange = () => { },
  add = {},
  // onOptions = () => { }
}) {
  totalInputs = Object.values(shownInputs).filter(v => v).length;
  allFormsValue = formsValue.linking ? formsValue : allFormsValue;
  const [MainForm] = Form.useForm();
  const [formData, setFormData] = useState({})
  const [form, setForm] = useState({});
  const [config, , v, d, opFilters, noDelete] = call.split('::');
  const [formEdit, setFormEdit] = useState(totalInputs && totalInputs === 1 && repeatIndex);
  const [data, setData] = useState({});
  const [disabledInputs, setDdisabledInputs] = useState([]);
  const [currentValue, setCurrentValue] = useState(value);
  const [entityData, setEntityData] = useState({});
  const [addedFromQuery, setAddedFromQuery] = useState({});
  const query = useQuery();
  const [loading, setLoading] = useState(false);
  const goTo = useNavigate();

  const createEndpoint = `${getApiBaseUrl()}/linking/check`;

  useEffect(() => {
    if (query.has('documentType') && query.get('documentType')) {
      if (sessionStorage.getItem('documentTypeAdded') !== 'true') {
        const length = allFormsValue.documents && Array.isArray(allFormsValue.documents)
          ? allFormsValue.documents.filter((d) => Object.keys(d).length).length : 0;
        setFormEdit(true);
        const type = query.get('documentType');
        setAddedFromQuery({ type });
        if (length) {
          sessionStorage.setItem('documentTypeAdded', true);
          goTo(`${window.location.pathname}?addedDocumentType=${type}`);
          add({});
        }
      }
    }
    if (query.has('addedDocumentType') && query.get('addedDocumentType')) {
      sessionStorage.removeItem('documentTypeAdded');
      setAddedFromQuery({ type: query.get('addedDocumentType') });
    }
  }, []);

  useEffect(() => {
    setCurrentValue(value);
    const formConf = props.linkingform || {};
    let optionFilters = [];
    try {
      optionFilters = JSON.parse(opFilters);
    } catch {

    }
    if (optionFilters.length) {
      optionFilters.filter(f => f.path && (f.includes || f.set)).forEach(f => {
        if (f.set) {
          dot.set(f.path, f.set, formConf);
        } else {
          let options = dot.pick(f.path, formConf);
          if (options && Array.isArray(options)) {
            options = options.filter(o => f.includes.includes(o.value));
            dot.set(f.path, options, formConf);
          }
        }
      })
    }
    const dInputs = d ? JSON.parse(d) : [];
    setDdisabledInputs(dInputs);
    if (
      props.datalink &&
      props.datalink.formNamespace &&
      allFormsValue.linking &&
      allFormsValue.linking[props.datalink.formNamespace] &&
      allFormsValue.linking[props.datalink.formNamespace][value]
    ) {
      const data = JSON.parse(JSON.stringify(allFormsValue.linking[props.datalink.formNamespace][value]));
      data.linking = JSON.parse(JSON.stringify(allFormsValue.linking));

      const extraData = [];
      if (!data.country) {
        extraData.push('country');
      }
      const formData = Object.assign(data || {}, getPredfinedValues(v ? JSON.parse(v) : {}, extraData));
      setData(formData);
      setFormData(formData);
      setEntityData(formData);
    } else {
      const extraData = [];
      if (!data || !data.country) {
        extraData.push('country');
      }
      const formData = Object.assign(data || {}, getPredfinedValues(v ? JSON.parse(v) : {}, extraData));
      setData(formData);
      setFormData(formData);
      setEntityData(formData);
    }
    const dPaths = noDelete ? JSON.parse(noDelete) : [];
    dPaths.forEach(k => {
      if (typeof dot.pick(k, formConf) === 'object') {
        dot.set(`${k}.deleteDataOnHide`, false, formConf);
      }
    });
    const ff = {}
    ff[name] = formConf[Object.keys(formConf)[0]];
    setForm(ff);
  }, [value, allFormsValue, props]);

  const getPredfinedValues = (predefinedValues, fromForm = []) => {
    Object.keys(predefinedValues).forEach(pv => {
      if (typeof predefinedValues[pv] === 'string' && predefinedValues[pv].split('./').length > 1) {
        const field = predefinedValues[pv].split('./')[1];
        let fValue = undefined;
        if (typeof repeatIndex === 'number' && Object.keys(repeatValues).length) {
          fValue = dot.pick(field, repeatValues);
        }
        if (!propHasValue(fValue)) {
          fValue = dot.pick(field, formsValue);
        }
        predefinedValues[pv] = fValue;
      }
    })
    if (formsValue && formsValue[name] && !allowDupplicates) {
      let preselectedValues = formsValue[name];
      if (Array.isArray(preselectedValues) && inputName) {
        preselectedValues = preselectedValues.map(pv => pv[inputName]).filter(pv => pv);
      } else if (typeof preselectedValues === 'object' && inputName) {
        preselectedValues = [preselectedValues[inputName]].filter(pv => pv);
      } else if (typeof preselectedValues === 'string') {
        preselectedValues = [preselectedValues].filter(pv => pv);
      } else {
        preselectedValues = [];
      }
      if (Array.isArray(preselectedValues) && preselectedValues.length > 0) {
        predefinedValues.preSelected = preselectedValues;
      }
    }
    fromForm.forEach(n => {
      predefinedValues[n] = formsValue[n];
    })
    return predefinedValues;
  }

  function checkForAutomaticallyLink() {
    const oldValue = currentValue;
    setCurrentValue(null);
    onChange(null);
    const formData = Object.assign({}, getPredfinedValues(v ? JSON.parse(v) : {}, ['country']));
    if (formData.preSelected && Array.isArray(formData.preSelected)) {
      formData.preSelected = formData.preSelected.filter(p => p !== oldValue);
    }
    setData(formData);
  }

  function submit(payload) {
    const requestConfig = config ? JSON.parse(config) : {};
    Object.keys(payload).forEach(key => {
      if (typeof payload[key] === 'object' && payload[key] !== null && propHasValue(payload[key])) {
        if (Object.keys(payload[key]).includes('fileList')) {
          const file = (payload[key].fileList || [])
            .map(file => file.response ? file.response : file)
            .filter(file => file && file.status === 'done');
          payload[key] = !Array.isArray(file)
            ? file : file.filter((v, i, a) => a.indexOf(v) === i);
        } else {
          Object.keys(payload[key]).forEach(oKey => {
            if (typeof payload[key][oKey] === 'object' && payload[key][oKey] !== null && propHasValue(payload[key][oKey]) &&
              Object.keys(payload[key][oKey]).includes('fileList')) {
              const file = (payload[key][oKey].fileList || [])
                .map(file => file.response ? file.response : file)
                .filter(file => file && file.status === 'done');
              payload[key][oKey] = !Array.isArray(file)
                ? file : file.filter((v, i, a) => a.indexOf(v) === i);
            }
          })
        }
      }
      if (Array.isArray(payload[key])) {
        // remove empty arrays
        payload[key] = payload[key].filter(f => typeof f !== 'object' || (Object.keys(f).length > 0 && Object.keys(f).filter(fk => propHasValue(f[fk])).length > 0));
      }
    });
    axios.post(createEndpoint, {
      ...requestConfig,
      data: Object.assign(payload, getPredfinedValues(v ? JSON.parse(v) : {})),
    }, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      },
    }).then(({ data }) => {
      setData(data);
      const [, dataId] = onNewSetValue.split('=');
      const cValue = dot.pick(dataId, data);
      setCurrentValue(cValue)
      onChange(cValue);
    }).catch((e) => {
      message.error(e.data ? e.data.message : e.message);
    })
  }

  const groupForm = mapFormGroup(form, formData);

  return currentValue ? <View
    formConfig={form}
    data={formData}
    allData={allFormsValue}
    checkForAutomaticallyLink={checkForAutomaticallyLink}
  /> : groupForm && Array.isArray(groupForm) && groupForm.length > 0 ? <div className="ajax-modal-edit">
    {formEdit ? <EditForm
      MainForm={MainForm}
      onSubmit={(payload) => submit(payload)}
      onCancel={() => setFormEdit(false)}
      onValuesChange={(val, all) => {
        setEntityData({ ...val, ...all });
      }}
      isModal={true}
      checkDuplicates={false}
      disabledInputs={disabledInputs || []}
      excludedKeys={[]}
      hasSections={false}
      linkingForms={{}}
      data={{ ...entityData, ...addedFromQuery, iN: name, inn: inputName }}
      form={groupForm[0]}
      loading={loading}
      setLoading={setLoading}
    /> : <div className="text-center">
      <div>{getInputProp(buttonText, allFormsValue)}</div>
      <div className="form-botom mt-2">
        <Button type="primary" onClick={() => setFormEdit(true)}>{i18next.t('Yes Add')}</Button>
      </div>
    </div>}
  </div> : null

}

const mstp = ({ authentication, logout }) => ({ authentication, logout });

export default connect(mstp)(AjaxModal);
